import { render } from "./JobAdmin.vue?vue&type=template&id=62bde5ae&scoped=true"
import script from "./JobAdmin.vue?vue&type=script&lang=js"
export * from "./JobAdmin.vue?vue&type=script&lang=js"

import "./JobAdmin.vue?vue&type=style&index=0&id=62bde5ae&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bde5ae"]])

export default __exports__